var _style, _polygon, _polygon2, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExodus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2502 514",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t\t.st0{fill:#ababab;}\r\n\t\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_1_);}\r\n\t")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2806318365744"
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "946.3,141.4 946.3,186.3 738.9,186.3 738.9,232.6 914.6,232.6 914.6,277.5 738.9,277.5 738.9,327.7  946.3,327.7 946.3,372.6 686.1,372.6 686.1,141.4  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "975.3,372.6 1094.2,255.7 978.6,141.4 1051.9,141.4 1133.1,224 1211.7,141.4 1279.7,141.4  1164.8,255.7 1283.7,372.6 1209.7,372.6 1133.1,287.4 1046,372.6  "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1426.3,184.4c-58.1,0-100.4,29.1-100.4,72.6c0,42.9,42.9,72.6,100.4,72.6c58.1,0,101-29.1,101-72.6 C1527.3,214.1,1484.4,184.4,1426.3,184.4z M1426.3,141.4c96.4,0,154.5,48.2,154.5,115.6s-58.1,115.6-154.5,115.6 s-153.9-48.2-153.9-115.6S1329.9,141.4,1426.3,141.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1841.7,256.3c0-45.6-27.1-70.7-75.9-70.7H1670V327h95.7c48.9,0,75.9-25.1,75.9-71.3V256.3z M1772.3,140.8 c77.3,0,123.5,42.9,123.5,115.6c0,73.3-46.2,116.2-122.8,116.2h-156.5V141.4h155.8V140.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2071.5,372.6c-81.2,0-142.6-37-142.6-105V141.4h53.5v121.5c0,42.3,43.6,61.4,89.8,61.4 c46.2,0,89.8-19.1,89.8-61.4V141.4h52.8v126.1c0,68-61.4,105-142.6,105H2071.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2362.7,372.6c-43.6,0-90.5-7.9-124.1-23.1l17.2-42.9c29.7,13.9,71.3,22.5,108.3,22.5 c42.9,0,82.5-9.2,82.5-25.1c0-11.9-12.5-16.5-39-20.5l-74.6-7.9c-57.4-7.9-85.2-27.7-85.2-62.1c0-44.9,47.5-71.3,116.9-71.3 c42.3,0,99.7,7.9,129.4,21.1l-17.2,40.9c-29.1-11.9-79.2-17.8-114.2-17.8c-36.3,0-60.1,8.6-60.1,23.8c0,10.6,11.9,15.8,42.9,20.5 l72,7.9c55.5,7.9,83.9,26.4,83.9,62.7c0,46.2-60.8,72-139.3,72L2362.7,372.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 210.931,
    y1: -195.8529,
    x2: -468.0689,
    y2: 460.1471,
    gradientTransform: "matrix(0.6603 0 0 -0.6603 323.7031 326.7972)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2964F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3373,
    style: {
      stopColor: "#6493F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4784,
    style: {
      stopColor: "#9FC3ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8588,
    style: {
      stopColor: "#8B63FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8C64FC"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M222.5,0.1L0,143.4L36.3,257L0,370.6l223.2,143.3V434L80.6,342.8l16.5-52.2h125.5V224H96.4l-16.5-52.2 l142.6-91.1V0.8V0.1z M290.5,0.1V80l142.6,91.1l-16.5,52.2H290.5V290h126.1l16.5,52.2l-142.6,91.1v79.9l222.5-143.3l-36.3-113.6 l36.3-113.6L290.5-0.5V0.1z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExodus);
export default __webpack_public_path__ + "static/media/exodus.005ad488632ed45c7fbfe884b786f2a7.svg";
export { ForwardRef as ReactComponent };